var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 16.0252C27.8123 15.1596 26.5154 13.8377 25.4592 12.9002L25.3967 12.8565C25.2927 12.773 25.1754 12.7075 25.0498 12.6627C22.503 12.1877 10.65 9.97214 10.4187 10.0003C10.3539 10.0093 10.292 10.0328 10.2375 10.069L10.1781 10.1159C10.105 10.1901 10.0495 10.2798 10.0156 10.3784L10 10.419V10.6409V10.6753C11.3344 14.3908 16.603 26.5625 17.6405 29.4188C17.703 29.6125 17.8218 29.9812 18.0436 30H18.0936C18.2124 30 18.7186 29.3313 18.7186 29.3313C18.7186 29.3313 27.7685 18.3564 28.6841 17.1877C28.8026 17.0437 28.9073 16.8889 28.9966 16.7252C29.0194 16.5971 29.0087 16.4653 28.9654 16.3427C28.9221 16.22 28.8478 16.1106 28.7498 16.0252ZM21.0405 17.3033L24.9029 14.1002L27.1685 16.1877L21.0405 17.3033ZM19.5405 17.0939L12.8906 11.644L23.6498 13.6283L19.5405 17.0939ZM20.1405 18.522L26.9467 17.4252L19.1655 26.8L20.1405 18.522ZM11.9875 12.1877L18.9843 18.1252L17.9718 26.8063L11.9875 12.1877Z",
    fill: "#FF060A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.6714406bd3409fa74fa8dc1ee498ae22.svg";
export { ForwardRef as ReactComponent };